import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import Cookies from 'universal-cookie';
import DatePicker from "react-datepicker";
import {onAuthStateChanged} from "firebase/auth";
import {auth} from "../../firebase-config";
import {padTo2Digits,formatDate,check_length,check_letters_only,check_numbers_only,check_date_format,check_email_format,check_phone_number} from "../../Helper";
import {db} from "../../firebase-config";
import {app} from "../../firebase-config";
import { async } from '@firebase/util';
import { getStorage, ref } from "firebase/storage";
import $ from 'jquery';
import Moment from 'moment';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where } from "firebase/firestore";

const PlayersFormModule = (props) => {
    const storage = getStorage();
    const [isLoading, setLoading] = useState(false);
    const cookies = new Cookies();
    const usersCollectionRef = collection(db,"users");
    const playersCollectionRef = collection(db,"players");

    //PLAYERS INFO
    const [name,setName] = useState("");
    const [birthdate, setBirthdate] = useState(new Date());
    const [gender,setGender] = useState("");
    const [address,setAddress] = useState("");
    const [city,setCity] = useState("");
    const [state,setState] = useState("");
    const [zip,setZip] = useState("");
    const [email,setEmail] = useState("");
    //PARENT 1
    const [parentName1,setParentName1] = useState("");
    const [homePhone1,setHomePhone1] = useState("");
    const [busPhone1,setBusPhone1] = useState("");
    const [parentEmail1,setParentEmail1] = useState("");
    const [parentCellphone1,setParentCellphone1] = useState("");
    const [parentText1,setParentText1] = useState("");
    //PARENT 2
    const [parentName2,setParentName2] = useState("");
    const [homePhone2,setHomePhone2] = useState("");
    const [busPhone2,setBusPhone2] = useState("");
    const [parentEmail2,setParentEmail2] = useState("");
    const [parentCellphone2,setParentCellphone2] = useState("");
    const [parentText2,setParentText2] = useState("");
    //Emergency
    const [emergencyName1,setEmergencyName1] = useState("");
    const [emergencyPhone1_1,setEmergencyPhone1_1] = useState("");
    const [emergencyPhone1_2,setEmergencyPhone1_2] = useState("");
    const [emergencyName2,setEmergencyName2] = useState("");
    const [emergencyPhone2_1,setEmergencyPhone2_1] = useState("");
    const [emergencyPhone2_2,setEmergencyPhone2_2] = useState("");

    const [playerAllergies,setPlayerAllergies] = useState("");
    const [playerMedConditions,setPlayerMedConditions] = useState("");

    const [physician,setPhysician] = useState("");
    const [physicianPhone,setPhysicianPhone] = useState("");
    const [physicianPhone2,setPhysicianPhone2] = useState("");

    const [insuranceCompany,setInsuranceCompany] = useState("");
    const [insuranceCompanyPhone,setInsuranceCompanyPhone] = useState("");
    const [policyHoldersName,setPolicyHoldersName] = useState("");
    const [policyNumber,setPolicyNumber] = useState("");

    const gender_change = (id) => {
      if(id == "female"){
        setGender("Female");
      }else{
        setGender("Male");
      }
    }

    const receivetexts = (id) => {
      if(id == "receivetexts_yes"){
        setParentText1("1");
      }else{
        setParentText1("0");
      }
    }
    const receivetexts2 = (id) => {
      if(id == "receivetexts_yes"){
        setParentText2("1");
      }else{
        setParentText2("0");
      }
    }
    const goback = () => {
      window.location = "/admin/players"
    }

    useEffect(()=>{
      if(isLoading){
          document.getElementById("data").style.display = "none";
          document.getElementById("loader").style.display = "block";
      }else{
          document.getElementById("data").style.display = "block";
          document.getElementById("loader").style.display = "none";
      }
  },[isLoading]);
  
  useEffect(()=>{
    if(props.action=="Modify Player"){
      setName(props.player.name);
      setBirthdate(props.player.birthdate?.toDate());
      gender_change(props.player.gender);
      props.player.gender=="Male"?document.getElementById("male").checked = true:document.getElementById("female").checked = true
      setAddress(props.player.address);
      setCity(props.player.city);
      setState(props.player.state);
      setZip(props.player.zip);
      setEmail(props.player.email);
      setParentName1(props.player.parentName1);
      setHomePhone1(props.player.homePhone1);
      setBusPhone1(props.player.busPhone1);
      setParentEmail1(props.player.parentEmail1);
      setParentCellphone1(props.player?.parentCellphone1);
      if(props.player.parentText1=="1"){
        document.getElementById("receivetexts_yes1").checked = true;
        setParentText1("1");
      }else{
        document.getElementById("receivetexts_no1").checked = true;
        setParentText1("0");
      }
      setParentName2(props.player.parentName2);
      setHomePhone2(props.player.homePhone2);
      setBusPhone2(props.player.busPhone2);
      setParentEmail2(props.player.parentEmail2);
      setParentCellphone2(props.player.parentCellphone2);
      if(props.player.parentText2=="1"){
        document.getElementById("receivetexts_yes2").checked = true;
        setParentText2("1");
      }else{
        document.getElementById("receivetexts_no2").checked = true;
        setParentText2("0");
      }
      setEmergencyName1(props.player.emergencyName1);
      setEmergencyPhone1_1(props.player.emergencyPhone1_1);
      setEmergencyPhone1_2(props.player.emergencyPhone1_2);
      setEmergencyName2(props.player.emergencyName2);
      setEmergencyPhone2_1(props.player.emergencyPhone2_1);
      setEmergencyPhone2_2(props.player.emergencyPhone2_2);
      setPlayerAllergies(props.player.playerAllergies);
      setPlayerMedConditions(props.player.playerMedConditions);
      setPhysician(props.player.physician);
      setPhysicianPhone(props.player.physicianPhone);
      setPhysicianPhone2(props.player.physicianPhone2);
      setInsuranceCompany(props.player.insuranceCompany);
      setInsuranceCompanyPhone(props.player.insuranceCompanyPhone);
      setPolicyHoldersName(props.player.policyHoldersName);
      setPolicyNumber(props.player.policyNumber);
    }
  },[]);

  const handleValidation = () => {
    let formIsValid = true;
    if(check_length(name,"error_name","yes")==false){formIsValid=false;}
    if(check_letters_only(name,"error_name","yes")==false){formIsValid=false;}
    if(check_date_format(birthdate,"error_birthdate","yes")==false){formIsValid=false;}
    if(check_length(gender,"error_gender","yes")==false){formIsValid=false;}
    if(check_length(address,"error_address","yes")==false){formIsValid=false;}
    if(check_length(city,"error_city","yes")==false){formIsValid=false;}
    if(check_letters_only(city,"error_city","yes")==false){formIsValid=false;}
    if(check_length(state,"error_state","yes")==false){formIsValid=false;}
    if(check_letters_only(state,"error_state","yes")==false){formIsValid=false;}
    if(check_length(zip,"error_zip","yes")==false){formIsValid=false;}
    if(check_numbers_only(zip,"error_zip","yes")==false){formIsValid=false;}
    if(check_length(email,"error_email","yes")==false){formIsValid=false;}
    if(check_email_format(email,"error_email","yes")==false){formIsValid=false;}

    if(check_length(parentName1,"error_parentname1","yes")==false){formIsValid=false;}
    if(check_letters_only(parentName1,"error_parentname1","yes")==false){formIsValid=false;}
    if(check_phone_number(homePhone1,"error_homephone1","no")==false){formIsValid=false;}
    if(check_phone_number(busPhone1,"error_parentbusphone1","no")==false){formIsValid=false;}
    if(check_length(parentEmail1,"error_parentemail1","yes")==false){formIsValid=false;}
    if(check_phone_number(parentCellphone1,"error_parentcellphone1","yes")==false){formIsValid=false;}
    if(check_length(parentText1,"error_parenttext1","yes")==false){formIsValid=false;}

    if(check_length(parentName2,"error_parentname2","no")==false){formIsValid=false;}
    if(check_letters_only(parentName2,"error_parentname2","no")==false){formIsValid=false;}
    if(check_phone_number(homePhone2,"error_homephone2","no")==false){formIsValid=false;}
    if(check_phone_number(busPhone2,"error_parentbusphone2","no")==false){formIsValid=false;}
    if(check_length(parentEmail2,"error_parentemail2","no")==false){formIsValid=false;}
    if(check_phone_number(parentCellphone2,"error_parentcellphone2","no")==false){formIsValid=false;}
    if(check_length(parentText2,"error_parenttext2","no")==false){formIsValid=false;}
  
    if(check_length(emergencyName1,"error_emergencyname1","yes")==false){formIsValid=false;}
    if(check_letters_only(emergencyName1,"error_emergencyname1","yes")==false){formIsValid=false;}
    if(check_phone_number(emergencyPhone1_1,"error_emergencyphone1_1","yes")==false){formIsValid=false;}
    if(check_phone_number(emergencyPhone1_2,"error_emergencyphone1_2","no")==false){formIsValid=false;}

    if(check_length(emergencyName2,"error_emergencyname2","no")==false){formIsValid=false;}
    if(check_letters_only(emergencyName2,"error_emergencyname2","no")==false){formIsValid=false;}
    if(check_phone_number(emergencyPhone2_1,"error_emergencyphone2_1","no")==false){formIsValid=false;}
    if(check_phone_number(emergencyPhone2_2,"error_emergencyphone2_2","no")==false){formIsValid=false;}

    if(check_length(playerAllergies,"error_allergies","yes")==false){formIsValid=false;}
    if(check_length(playerMedConditions,"error_medicalconditions","yes")==false){formIsValid=false;}
    if(check_length(physician,"error_physician","no")==false){formIsValid=false;}
    if(check_phone_number(physicianPhone,"error_physicianphone","no")==false){formIsValid=false;}
    if(check_phone_number(physicianPhone2,"error_physicianphone2","no")==false){formIsValid=false;}
    if(check_length(insuranceCompany,"error_insurancecompany","no")==false){formIsValid=false;}
    if(check_letters_only(insuranceCompany,"error_insurancecompany","no")==false){formIsValid=false;}
    if(check_phone_number(insuranceCompanyPhone,"error_insurancecompanyphone","no")==false){formIsValid=false;}
    if(check_length(policyHoldersName,"error_policyholdersname","no")==false){formIsValid=false;}
    if(check_letters_only(policyHoldersName,"error_policyholdersname","no")==false){formIsValid=false;}
    if(check_length(policyNumber,"error_policynumber","no")==false){formIsValid=false;}

    return formIsValid;
  }
  //Name

  const updateplayer = async () => {
    setLoading(true);
    if (handleValidation()) {
      const userDoc = doc(db, "players", cookies.get("player"));
      var date = new Date();
      const newFields = { 
        name: name,
        birthdate: birthdate,
        gender: gender,
        address: address,
        city: city,
        state: state,
        zip: zip,
        email: email,
        parentName1: parentName1,
        homePhone1: homePhone1,
        busPhone1: busPhone1,
        parentEmail1: parentEmail1,
        parentCellphone1, parentCellphone1,
        parentText1: parentText1,
        parentName2: parentName2,
        homePhone2: homePhone2,
        busPhone2: busPhone2,
        parentEmail2: parentEmail2,
        parentCellphone2: parentCellphone2,
        parentText2: parentText2,
        emergencyName1: emergencyName1,
        emergencyPhone1_1: emergencyPhone1_1,
        emergencyPhone1_2: emergencyPhone1_2,
        emergencyName2: emergencyName2,
        emergencyPhone2_1: emergencyPhone2_1,
        emergencyPhone2_2: emergencyPhone2_2,
        playerAllergies: playerAllergies,
        playerMedConditions: playerMedConditions,
        physician: physician,
        physicianPhone: physicianPhone,
        physicianPhone2: physicianPhone2,
        insuranceCompany: insuranceCompany,
        insuranceCompanyPhone: insuranceCompanyPhone,
        policyHoldersName: policyHoldersName,
        policyNumber: policyNumber,
        modified: date,
        by: props.userHome.userData.name };
      await updateDoc(userDoc, newFields).then((res)=>{
        console.log(res);
        setLoading(false);
        cookies.set('player', cookies.get("player"), { path: '/' });
        cookies.set('player_name', name, { path: '/' });
        props.updateStatePlayer(1,name,res);
      });
    } else {
      alert("Form has errors.");
      setLoading(false);
    }
  }
  
  const saveplayer = async () => {
    setLoading(true);
    if (handleValidation()) {
        var date = new Date();
        await addDoc(playersCollectionRef,{
          id:props.userHome.userHome.uid,
          date: date,
          name: name,
          birthdate: birthdate,
          gender: gender,
          address: address,
          city: city,
          state: state,
          zip: zip,
          email: email,
          parentName1: parentName1,
          homePhone1: homePhone1,
          busPhone1: busPhone1,
          parentEmail1: parentEmail1,
          parentCellphone1: parentCellphone1,
          parentText1: parentText1,
          parentName2: parentName2,
          homePhone2: homePhone2,
          busPhone2: busPhone2,
          parentEmail2: parentEmail2,
          parentCellphone2:parentCellphone2,
          parentText2: parentText2,
          emergencyName1: emergencyName1,
          emergencyPhone1_1: emergencyPhone1_1,
          emergencyPhone1_2: emergencyPhone1_2,
          emergencyName2: emergencyName2,
          emergencyPhone2_1: emergencyPhone2_1,
          emergencyPhone2_2: emergencyPhone2_2,
          playerAllergies: playerAllergies,
          playerMedConditions: playerMedConditions,
          physician: physician,
          physicianPhone: physicianPhone,
          physicianPhone2: physicianPhone2,
          insuranceCompany: insuranceCompany,
          insuranceCompanyPhone: insuranceCompanyPhone,
          policyHoldersName: policyHoldersName,
          policyNumber: policyNumber,
          club_id: props.userHome.userData.club_id,
          active_program: "0",
          program_name: "",
          end_date: "May 10, 2015 at 9:42:39 AM UTC-7",
        }).then((res) => {
          console.log(res);
          setLoading(false);
          cookies.set('player', res.id, { path: '/' });
          cookies.set('player_name', name, { path: '/' });
          props.updateStatePlayer(1,name,props.player);
        });
    } else {
      alert("Form has errors.");
      setLoading(false);
    }
  }

return (
  <div>
    <div id="data">
        <h2>{props.action}</h2>
        <Card>
            <Card.Body>
                <Card.Title className='bg-info'>Club Information</Card.Title>
                <div className='row'>
                  <div className='col-lg-1'>
                      Club Name:
                  </div>
                  <div className='col-lg-3'>
                      <b>SENTINELS SOCCER CLUB</b>
                  </div>
                  <div className='col-lg-2'>
                      City:
                  </div>
                  <div className='col-lg-2'>
                      <b>Morgan Hill, San Martin, Gilroy</b>
                  </div>
                  <div className='col-lg-2'>
                      State:
                  </div>
                  <div className='col-lg-2'>
                      <b>CA</b>
                  </div>
                  <div className='col-lg-1'>
                      League Name:
                  </div>
                  <div className='col-lg-2'>
                      <b>NorCal</b>
                  </div>
                </div>
            </Card.Body>
          </Card><br/>
          <Card>
            <Card.Body>
                <Card.Title className='bg-info'>Player Information</Card.Title>
                <div className='row'>
                  <div className='col-lg-1'>
                      Player's Name:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={name}
                        onChange={(event)=>{setName(event.target.value)}} ></input>
                      <span style={{ color: "red" }} id="error_name"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                      Birth Date:
                  </div>
                  <div className='col-lg-2'>
                      <DatePicker className='form-control' showYearDropdown showMonthDropdown selected={birthdate} onChange={(date) => setBirthdate(date)} />
                      <span style={{ color: "red" }} id="error_birthdate"></span>
                  </div>
                  <div className='col-lg-2'>
                      Gender:
                  </div>
                  <div className='col-lg-2'>
                    <label htmlFor="female">Female</label>
                    <input type="radio" name="gender" id="female"  onChange={() => gender_change("female")}></input>
                    <label htmlFor="male">Male</label>
                    <input type="radio" name='gender' id="male"  onChange={() => gender_change("male")}></input>
                    <span style={{ color: "red" }} id="error_gender"></span>
                  </div>
                  <div className='col-lg-1'>
                      Address:
                  </div>
                  <div className='col-lg-7'>
                    <input type="text" className='form-control' value={address}
                        onChange={(event)=>{setAddress(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_address"></span>
                  </div>
                  <div className='col-lg-2'>
                      City:
                  </div>
                  <div className='col-lg-2'>
                      <input type="text" className='form-control' value={city}
                        onChange={(event)=>{setCity(event.target.value)}} ></input>
                      <span style={{ color: "red" }} id="error_city"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      State:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={state}
                        onChange={(event)=>{setState(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_state"></span>
                  </div>
                  <div className='col-lg-1'>
                      ZIP:
                  </div>
                  <div className='col-lg-3'>
                      <input type="number" className='form-control' value={zip}
                        onChange={(event)=>{setZip(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_zip"></span>
                  </div>
                  <div className='col-lg-1'>
                      Email Address:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={email}
                        onChange={(event)=>{setEmail(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_email"></span>
                  </div>
                </div>
            </Card.Body>
          </Card><br/>
          <Card>
            <Card.Body>
                <Card.Title className='bg-info'>Parent's Information</Card.Title>
                <div className='row'>
                <div className='col-lg-1'>
                      Parent Name:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={parentName1}
                        onChange={(event)=>{setParentName1(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_parentname1"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      Home Phone:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={homePhone1}
                        onChange={(event)=>{setHomePhone1(event.target.value)}} ></input>
                      <span style={{ color: "red" }} id="error_homephone1"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      Bus. Phone:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={busPhone1}
                        onChange={(event)=>{setBusPhone1(event.target.value)}} ></input>
                      <span style={{ color: "red" }} id="error_parentbusphone1"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      Email Address:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={parentEmail1}
                        onChange={(event)=>{setParentEmail1(event.target.value)}} ></input>
                      <span style={{ color: "red" }} id="error_parentemail1"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                    Cell Phone:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={parentCellphone1}
                        onChange={(event)=>{setParentCellphone1(event.target.value)}} ></input>
                      <span style={{ color: "red" }} id="error_parentcellphone1"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      Receive Texts?
                  </div>
                  <div className='col-lg-3'>
                    <label htmlFor="receivetexts_yes1">Yes</label>
                    <input type="radio" name="receivetexts" id="receivetexts_yes1" onChange={() => receivetexts("receivetexts_yes")}></input>
                    <label htmlFor="receivetexts_no1">No</label>
                    <input type="radio" name='receivetexts' id="receivetexts_no1" onChange={() =>  receivetexts("receivetexts_no")}></input>
                    <span style={{ color: "red" }} id="error_parenttext1"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      Parent Name:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={parentName2}
                        onChange={(event)=>{setParentName2(event.target.value)}} ></input>
                      <span style={{ color: "red" }} id="error_parentname2"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      Home Phone:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={homePhone2}
                        onChange={(event)=>{setHomePhone2(event.target.value)}} ></input>
                      <span style={{ color: "red" }} id="error_parentphone2"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      Bus. Phone:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={busPhone2}
                        onChange={(event)=>{setBusPhone2(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_parentbusphone2"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      Email Address:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={parentEmail2}
                        onChange={(event)=>{setParentEmail2(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_parentemail2"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                    Cell Phone:
                  </div>
                  <div className='col-lg-3'>
                      <input type="text" className='form-control' value={parentCellphone2}
                        onChange={(event)=>{setParentCellphone2(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_parentcellphone2"></span><br></br>
                  </div>
                  <div className='col-lg-1'>
                      Receive Texts?
                  </div>
                  <div className='col-lg-3'>
                  <label for="receivetexts_yes2">Yes</label>
                    <input type="radio" name="receivetexts2" id="receivetexts_yes2" onChange={() => receivetexts2("receivetexts_yes")}></input>
                    <label for="receivetexts_no2">No</label>
                    <input type="radio" name='receivetexts2' id="receivetexts_no2" onChange={() =>  receivetexts2("receivetexts_no")}></input>
                    <span style={{ color: "red" }} id="error_parenttext2"></span><br></br>
                  </div>
                  
                </div>
            </Card.Body>
          </Card><br></br>
          <Card>
            <Card.Body>
                <Card.Title className='bg-info'>In an emergency when parent/guardian cannot be reached, please contact the following:</Card.Title>
                <div className='row'>
                  <div className='col-lg-2'>
                    Name:
                  </div>
                  <div className='col-lg-2'>
                    <input type="text" className='form-control' value={emergencyName1}
                        onChange={(event)=>{setEmergencyName1(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_emergencyname1"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Phone 1:
                  </div>
                  <div className='col-lg-2'>
                    <input type="text" className='form-control' value={emergencyPhone1_1}
                        onChange={(event)=>{setEmergencyPhone1_1(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_emergencyphone1_1"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Phone 2:
                  </div>
                  <div className='col-lg-2'>
                    <input type="text" className='form-control' value={emergencyPhone1_2}
                        onChange={(event)=>{setEmergencyPhone1_2(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_emergencyphone1_2"></span><br></br>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-2'>
                    Name:
                  </div>
                  <div className='col-lg-2'>
                    <input type="text" className='form-control' value={emergencyName2}
                        onChange={(event)=>{setEmergencyName2(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_emergencyname2"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Phone 1:
                  </div>
                  <div className='col-lg-2'>
                    <input type="text" className='form-control' value={emergencyPhone2_1}
                        onChange={(event)=>{setEmergencyPhone2_1(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_emergencyphone1_1"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Phone 2:
                  </div>
                  <div className='col-lg-2'>
                    <input type="text" className='form-control' value={emergencyPhone2_2}
                        onChange={(event)=>{setEmergencyPhone2_2(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_emergencyphone1_2"></span><br></br>
                  </div>
                </div>
            </Card.Body>
          </Card><br></br>
          <Card>
            <Card.Body>
                <Card.Title className='bg-info'>Medical conditions</Card.Title>
                <div className='row'>
                  <div className='col-lg-2'>
                    Please list player allergies:
                  </div>
                  <div className='col-lg-10'>
                    <input type="text" className='form-control' value={playerAllergies}
                        onChange={(event)=>{setPlayerAllergies(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_allergies"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Please list other medical conditions:
                  </div>
                  <div className='col-lg-10'>
                    <input type="text" className='form-control' value={playerMedConditions}
                        onChange={(event)=>{setPlayerMedConditions(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_medicalconditions"></span><br></br>
                  </div>
                </div>
            </Card.Body>
          </Card><br></br>
          <Card>
            <Card.Body>
                <Card.Title className='bg-info'></Card.Title>
                <div className='row'>
                  <div className='col-lg-2'>
                    Physician:
                  </div>
                  <div className='col-lg-2'>
                    <input type="text" className='form-control' value={physician}
                        onChange={(event)=>{setPhysician(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_physician"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Phone 1:
                  </div>
                  <div className='col-lg-2'>
                    <input type="text" className='form-control' value={physicianPhone}
                        onChange={(event)=>{setPhysicianPhone(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_physicianphone"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Phone 2:
                  </div>
                  <div className='col-lg-2'>
                    <input type="text" className='form-control' value={physicianPhone2}
                        onChange={(event)=>{setPhysicianPhone2(event.target.value)}} ></input>
                        <span style={{ color: "red" }} id="error_physicianphone2"></span><br></br>
                  </div>
                </div>
                <div className='row'>
                <div className='col-lg-2'>
                    Medical/Hospital Insurance Company:
                  </div>
                  <div className='col-lg-4'>
                    <input type="text" className='form-control' value={insuranceCompany}
                        onChange={(event)=>{setInsuranceCompany(event.target.value)}} ></input>
                         <span style={{ color: "red" }} id="error_insurancecompany"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Phone:
                  </div>
                  <div className='col-lg-4'>
                    <input type="text" className='form-control' value={insuranceCompanyPhone}
                        onChange={(event)=>{setInsuranceCompanyPhone(event.target.value)}} ></input>
                         <span style={{ color: "red" }} id="error_insurancecompanyphone"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Policy Holder's Name:
                  </div>
                  <div className='col-lg-4'>
                    <input type="text" className='form-control' value={policyHoldersName}
                        onChange={(event)=>{setPolicyHoldersName(event.target.value)}} ></input>
                         <span style={{ color: "red" }} id="error_policyholdersname"></span><br></br>
                  </div>
                  <div className='col-lg-2'>
                    Policy Number:
                  </div>
                  <div className='col-lg-4'>
                    <input type="text" className='form-control' value={policyNumber}
                        onChange={(event)=>{setPolicyNumber(event.target.value)}} ></input>
                         <span style={{ color: "red" }} id="error_policynumber"></span><br></br>
                  </div>
                </div>
            </Card.Body>
          </Card>
          <button onClick={goback} className="btn btn-primary">Cancel</button>
          <button onClick={props.action=="Modify Player"?updateplayer:saveplayer } className="btn btn-success">Save</button>
        </div>
        <div className="loader-container" id="loader">
            <div className="loader"></div>
        </div>
      </div>
)

}

export default PlayersFormModule;